import { Controller } from 'stimulus'
import { MAPBOX_ACCESS_TOKEN } from '../config';

import $ from 'jquery';
import autocomplete from 'jquery-ui/ui/widgets/autocomplete';

export default class extends Controller {
  connect() {
    this._originEl = this.element.querySelector('[data-id=place]');
    this._exactOriginEl = this.element.querySelector('[data-id=exact-place]');
    this._exactOriginLatLngEl = this.element.querySelector('[data-id=exact-place-latlng]');

    // keep origin value to fetch bbox for it when it changed
    this._originElValue = '';
    this._bbox = [];

    this.initAutocomplete();
  }

  initAutocomplete() {
    $(this._exactOriginEl).autocomplete({
      source: (request, response) => this.fetchData(request, response),
      minLength: 3,
      delay: 200,
      select: (event, ui) => {
        this._exactOriginLatLngEl.value = `POINT(${ ui.item.coordinates[0] } ${ ui.item.coordinates[1] })`
      }
    })
  }

  fetchData(request, response) {
    const place = request.term;

    if (this._originEl.value.length != 0) {
      if (this._originElValue == this._originEl.value) {
        this.fetchBoundedPlace(place, response);
      } else {
        this._originElValue = this._originEl.value;
        this._bbox = [];
        $.ajax({
          url: this.bboxURLTemplate(this._originElValue),
          success: (data) => {
            this._bbox = data.features[0].bbox;
            this.fetchBoundedPlace(place, response);
          }
        })
      }
    } else {
      this._originElValue = this._originEl.value;
      this._bbox = [];
    }
  }

  fetchBoundedPlace(place, response) {
    $.ajax({
      url: this.boundedURLTemplate(place),
      success: (data) => {
        response(data.features.map(this.serialize))
      }
    })
  }

  serialize(feature) {
    return {
      label: feature.place_name,
      coordinates: feature.geometry.coordinates
    }
  }

  boundedURLTemplate(place) {
    const encodedPlace = encodeURIComponent(place);

    return `https://api.mapbox.com/geocoding/v5/mapbox.places/${ encodedPlace }.json?country=US,CA&types=address,poi&bbox=${ this._bbox.join() }&limit=10&access_token=${ MAPBOX_ACCESS_TOKEN }`;
  }

  bboxURLTemplate(place) {
    const encodedPlace = encodeURIComponent(place);

    return `https://api.mapbox.com/geocoding/v5/mapbox.places/${ encodedPlace }.json?country=US,CA&types=place&limit=1&access_token=${ MAPBOX_ACCESS_TOKEN }`;
  }
}
